import React from "react";
import AdminRoutes from "../routes/AdminRoutes";
import Sidebar from "../components/common/Sidebar";
import Header from "../components/common/Header";
import { SidebarProvider, useSidebar } from "../context/SidebarContext";
import { useLocation } from "react-router-dom";

const AdminLayoutContent: React.FC = () => {
  const { sidebarWidth } = useSidebar();
  const location = useLocation();
  const isDashboard = location.pathname === "/admin/dashboard";

  return (
    <div className="min-h-screen bg-slate-100 text-slate-900">
      <Sidebar />

      <div
        className="min-h-screen transition-[margin] duration-200"
        style={{ marginLeft: `${sidebarWidth}px` }}
      >
        {!isDashboard && <Header />}

        <main className={`h-screen overflow-y-auto ${isDashboard ? "pt-0" : "pt-14"}`}>
          <div className="mx-auto w-full max-w-[1800px] px-3 py-3 md:px-4 lg:px-5">
            <AdminRoutes />
          </div>
        </main>
      </div>
    </div>
  );
};

const AdminLayout: React.FC = () => (
  <SidebarProvider>
    <AdminLayoutContent />
  </SidebarProvider>
);

export default AdminLayout;
